import { Alert, Row, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { startCase, toLower } from 'lodash'
import { useUpdateIssueLog } from 'api/hooks/use-issue-logs'
import { useQueryClient } from 'react-query'

export default function IgnoredAlert({ log }) {
  const queryClient = useQueryClient()
  const { mutate } = useUpdateIssueLog({
    params: {
      id: log.id,
      ignore_type: '',
      ignore_comments: '',
      ignore_expiration_until: null,
      ignore_at: null,
      status: 'unresolved'
    },
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries(['issue-logs'])
      }
    }
  })

  return (
    <Alert
      variant="warning"
      className="d-flex flex-column"
      style={{
        backgroundColor: '#FEFCE8',
        borderLeft: '4px solid #FACC15',
        padding: '1rem'
      }}
    >
      <div className="d-flex align-items-center mb-2">
        <div className="me-3" style={{ alignSelf: 'center' }}>
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            aria-hidden="true"
            style={{ width: '20px', height: '20px', color: '#FACC15' }}
          />
        </div>
        <div style={{ flex: 1 }}>
          {/* Additional Info */}
          <Row style={{ fontSize: '0.875rem', color: '#B45309' }}>
            <Col sm="auto">
              <span>
                <strong>Ignore By:</strong> {log.ignore_by}
              </span>
            </Col>
            <Col sm="auto">
              <span>
                <strong>Ignore Type:</strong>{' '}
                {startCase(toLower(log.ignore_type))}
              </span>
            </Col>
            <Col sm="auto">
              <span>
                <strong>Ignore Until:</strong>{' '}
                {new Date(log.ignore_expiration_until).toLocaleString()}
              </span>
            </Col>
          </Row>
          <Row style={{ fontSize: '0.875rem', color: '#B45309' }}>
            <Col sm="auto">
              <span>
                <strong>Ignore Comments:</strong> {log.ignore_comments}
              </span>
            </Col>
          </Row>
        </div>
        <button
          className="btn btn-danger text-white ms-3"
          onClick={() => mutate()}
        >
          Remove Ignore
        </button>
      </div>
    </Alert>
  )
}
